<template>
   <div class="form-group">
      <label
         for="ip_email"
         :class="['label-overlay', { active: !isNotEmpty(form.email) }]"
         @click="switchLabel($event)"
      >
         Work Email
      </label>
      <input
         id="ip_email"
         v-model.trim="form.email"
         type="text"
         class="form-control"
         name="email"
         :class="[
            { 'is-invalid': isValidMail.inValidLength },
            { 'is-invalid': isValidMail.inValidAttampt },
            { 'is-valid': isValidMail.isValid },
         ]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateMailData();
            initiatedType();
         "
      />
      <div class="invalid-feedback">Please enter valid email.</div>
      <div class="valid-feedback">Sounds good.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';

export default {
   name: 'EmailComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidMail: {
            inValidAttampt: false,
            inValidLength: false,
            isValid: false,
         },
         form: {
            email: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         this.form.email = this.person.profileData.email || '';
      }
   },
   methods: {
      validateMailData() {
         this.isValidMail = {
            inValidAttampt: this.$parent.attemptSubmit && this.isValidEmail,
            inValidLength: this.form.email.length !== 0 && this.isValidEmail,
            isValid: !this.isValidEmail,
         };
      },
      reset() {
         this.isValidMail.inValidAttampt = false;
         this.isValidMail.inValidLength = false;
         this.isValidMail.isValid = false;
         this.form.email = '';
      },

      initiatedType() {
         if (this.form.email !== '') {
            this.userProfileTracker.information({ email: this.form.email });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;
            this.tracker(this.options.mixpanelEve, {
               ...(this.options.name && { Name: this.options.name }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
